import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider.js';

export default class ProductRelatedProducts {
	constructor({ container }) {
		this.container = container;
		this.initSlider();
	}

	initSlider() {

		let slider_opts = {
			container: this.container,
			axis: 'horizontal',
			items: 1,
			gutter: 0,
			edgePadding: 50,
			nav: false,
			loop: false,
			responsive: {
				992: {
					items: 2
				},
				1200: {
					items: 3,
				},
				1400: {
					items: 4
				},
				1600: {
					items: 5
				},
				1900: {
					items: 6
				}
			}
		};

		this.slider = tns(slider_opts);

	}

};